import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';

import { COLORS } from '../../../../utils/styles';

export const Wrapper = styled.div`
  text-align: left;
`;

export const Title = styled.h3`
  color: ${COLORS.slateGray};
  font-weight: 100;
  font-size: 19px;
  font-family: 'FiraSansUltraLight';
`;

export const LinksWrapper = styled(Row)`
  margin-top: 0px;
`;

export const Left = styled(Col)`
  text-align: left;
`;

export const Right = styled(Col)`
  text-align: right;
`;

export const ButtonsWrappers = styled(Row)`
  margin: 30px 0px;
`;



// WEBPACK FOOTER //
// ./src/views/officials-connect/components/LoginBox/styled-components.js